import axios from 'axios'
import utils from '@/plugins/utils'

const CV_API = '/cvs/'
const ACTIVE_CODE_API = '/active-codes/'
const AUTH_API = '/auth/local'
const USER_API = '/users/'
const UPLOAD_API = '/upload/'
const DESTROY_API = '/upload/files/'
const PHONE_REGISTER_API = '/phone-registers/'
const NOTIFICATION_API = '/posts/'
const TRANSACTION_API = '/transactions/'
const ADSPOPUP_API = '/ads-popups/'
const EVENT_API = '/events/'
const EVENT_SLOT_API = '/event-slots/'
const EVENT_SLOT_STUDENT_API = '/event-slot-cvs/'
const ENROLL_FORM_API = '/enroll-forms/'
const ENROLL_CLASS_API = '/enroll-classes/'
const ENROLL_DEADLINE_API = '/enroll-deadlines/'
const ENROLL_CUTOFF_MARK_API = '/enroll-cutoff-marks/'
const CV_DEADLINE_API = '/cv-deadlines/'

const APIHelper = api => ({
  search: (params, option) => axios.get(api, {params: utils.filterObject(params)}, option),
  count: (params, option) => axios.get(api + 'count', {params: utils.filterObject(params)}, option),
  fetch: (params, option) => axios.get(api, {params: utils.filterObject(params)}, option),
  fetchOne: (id, option) => axios.get(api + id, option),
  create: (params, options) => axios.post(api, utils.filterObject(params), options),
  update: (id, params, option) => axios.put(api + id, utils.filterObject(params), option),
  remove: (id, option) => axios.delete(api + id, option),
})
export const APIRespository = APIHelper
export const Auth = {
  ...APIHelper(AUTH_API),
  requestResetOTP: userPhone =>
    axios.post(`/request-otp`, {
      userPhone,
      requestType: 'reset-password',
    }),
  confirmResetOTP: (userPhone, otp) =>
    axios.post(`/confirm-reset-password/${userPhone}`, {
      otp,
    }),
  changePassword: (userPhone, newPassword, confirmNewPassword) =>
    axios.put(`/change-password/${userPhone}`, {
      newPassword,
      confirmNewPassword,
    }),
  register: (phone, password, email) =>
    axios.post('/auth/local/register', {
      username: phone,
      password,
      email,
    }),
  requestRegisterOTP: userPhone =>
    axios.post(`/request-otp`, {
      userPhone,
      requestType: 'register',
    }),
  confirmSignupOTP: (userPhone, otp) =>
    axios.post(`/confirm-register`, {
      userPhone,
      otp,
    }),
}
export const CV = {
  ...APIHelper(CV_API),
  create: (code, params) =>
    axios.post(`/cvs/${code}`, {
      ...params,
    }),
  update: (code, params) =>
    axios.put(`/cvs/${code}`, {
      ...params,
    }),
  checkDocumentSystemTime: params =>
    axios.post(`/checkDocumentSystemTime`, {
      ...params,
    }),
  checkSystemTime: () => axios.get(`/checkSystemTime`),
  startHourlySMSTask: () => axios.get(`/startHourlySMSTask`),
  stopHourlySMSTask: () => axios.get(`/stopHourlySMSTask`),
  getDashboardStats: type => axios.get(`/cvs-get-dashboard-stats?type=${type}`),
  getCountCreateByDayRange: params => axios.get('/cvs-get-count-created-day-range', {params}),
  updateRetry: (code, params) => axios.put(`/cvs/update-retry/${code}`, params),
  cancelRegisterG6ExamPrep: id => axios.put(`/cvs/cancelRegisterG6ExamPrep/${id}`),
  cancelRegisterG10ExamTrial: (id, data) => axios.put(`/cvs/cancelRegisterG10ExamTrial/${id}`, data),
  cancelRegisterG6Retry2: (id, data) => axios.put(`/cvs/cancelRegisterG6Retry2/${id}`, data),
  grantEnrollmentPermBatch: data => axios.post(`${CV_API}enrollment/grant-perm-batch`, data),
  grantEnrollmentPermSingle: data => axios.post(`${CV_API}enrollment/grant-perm-single`, data),
}
export const ActiveCode = {
  ...APIHelper(ACTIVE_CODE_API),
  validate: code =>
    axios.post(`/active-codes/validate`, {
      code,
    }),
  enableActiveCode: code => axios.put(`/active-codes/enable-code/${code}`, {}),
  disableActiveCode: code => axios.put(`/active-codes/disable-code/${code}`, {}),
  getDashboardStats: params => axios.get('/active-codes-dashboard-stats', {params}),
}
export const User = {
  ...APIHelper(USER_API),
  getUserStats: params => axios.get('/user-stat/active', {params}),
  getSmsStats: params => axios.get('/user-stat/otp', {params}),
  fetchUserForAdmin: params => axios.get('/users-admin', {params}),
  countUserForAdmin: params => axios.get('/users-admin/count', {params: utils.filterObject(params)}),
  fetchUserForExcel: params => axios.get('/users-admin-excel', {params: utils.filterObject(params)}),
  upgradeWhitelist: (id, params = {}) => axios.put(`/users-admin/upgrade-whitelist/${id}`, params),
}
export const Upload = {
  upload: formData =>
    axios.post(UPLOAD_API, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
  destroy: id => axios.delete(DESTROY_API + id),
}

export const PhoneRegister = APIHelper(PHONE_REGISTER_API)

export const Notification = APIHelper(NOTIFICATION_API)

export const Transaction = APIHelper(TRANSACTION_API)

export const AdsPopup = APIHelper(ADSPOPUP_API)

export const Event = {
  ...APIHelper(EVENT_API),
  update: (id, params, option) => axios.put('/events/' + id, params, option),
  duplicate: (data, options) => axios.post('/events/duplicate', data, options),
}
export const EventSlot = {
  ...APIHelper(EVENT_SLOT_API),
  updateIndex: (id, params, options) => axios.put('/event-slots/update-index/' + id, params, options),
}
export const EventSlotStudent = {
  ...APIHelper(EVENT_SLOT_STUDENT_API),
  changeSlot: (id, params, options) => axios.put(EVENT_SLOT_STUDENT_API + 'change-slot/' + id, params, options),
}
export const EnrollForm = {
  ...APIHelper(ENROLL_FORM_API),
  findForAssignClass: params => axios.get(`${ENROLL_FORM_API}ass`, {params: utils.filterObject(params)}),
  exportAssignClass: params => axios.get(`${ENROLL_FORM_API}ass/excel`, {params: utils.filterObject(params)}),
  updateAssignClass: (id, params) => axios.put(`${ENROLL_FORM_API}ass/${id}`, params),
  updateDocumentStates: (id, params) => axios.put(`${ENROLL_FORM_API}ass/doc-states/${id}`, params),
  countForAssignClass: params => axios.get(`${ENROLL_FORM_API}ass/count`, {params: utils.filterObject(params)}),
  withdrawDocument: (id, params) => axios.put(`${ENROLL_FORM_API}ass/withdraw/${id}`, params),
  displaceAssignedClass: (id, params) => axios.put(`${ENROLL_FORM_API}ass/displace/${id}`, params),
}
export const EnrollClasses = APIHelper(ENROLL_CLASS_API)
export const EnrollDeadline = {
  ...APIHelper(ENROLL_DEADLINE_API),
  setDeadline: params => axios.post(`${ENROLL_DEADLINE_API}set-deadline`, params),
}
export const EnrollCutoffMark = {
  ...APIHelper(ENROLL_CUTOFF_MARK_API),
  upgrade: params => axios.post(`${ENROLL_CUTOFF_MARK_API}upgrade`, params),
}
export const CvDeadline = {
  ...APIHelper(CV_DEADLINE_API),
  upgrade: params => axios.post(`${CV_DEADLINE_API}upgrade`, params),
}

export default {
  Auth,
  CV,
  Upload,
  User,
  ActiveCode,
  PhoneRegister,
  Notification,
  Transaction,
  AdsPopup,
  Event,
  EventSlot,
  EventSlotStudent,
  EnrollForm,
  EnrollClasses,
  EnrollDeadline,
  EnrollCutoffMark,
  CvDeadline,
}
